module.exports = __webpack_public_path__ + "media/images/icon/i-costing-136a05af8a0aa4d5bd103236d893b464.svg";